var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "checkbox-input",
      class: { "checkbox-input--toggle": _vm.toggle }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.isChecked,
            expression: "isChecked"
          }
        ],
        staticClass: "checkbox-input__input",
        attrs: {
          type: "checkbox",
          disabled: _vm.disabled,
          name: _vm.name,
          id: _vm.inputId
        },
        domProps: {
          value: _vm.value || _vm.label,
          checked: Array.isArray(_vm.isChecked)
            ? _vm._i(_vm.isChecked, _vm.value || _vm.label) > -1
            : _vm.isChecked
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.isChecked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.value || _vm.label,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isChecked = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isChecked = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isChecked = $$c
              }
            },
            _vm.onChange
          ]
        }
      }),
      _c("span", { staticClass: "checkbox-input__checkbox" }, [
        !_vm.toggle
          ? _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 16 14",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "currentColor"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z",
                    fill: "currentColor"
                  }
                })
              ]
            )
          : _vm._e()
      ]),
      _vm.label
        ? _c("div", { staticClass: "checkbox-input__label-text" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _c(
            "div",
            { staticClass: "checkbox-input__label-text" },
            [_vm._t("default")],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }